import { render } from "./BuildingImageDisplay.vue?vue&type=template&id=4298ef9a"
import script from "./BuildingImageDisplay.vue?vue&type=script&lang=js"
export * from "./BuildingImageDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__